import { useEffect, useState } from "react";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { TAG_MISSING_REPORT } from "../interfaces/dashboard";
import { TAG_MISSING_REPORT_DATA } from "../constants/data.cnst";
import Reports from "../components/reports";

export default function TagMissing() {

    const tagMissingReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.TAG_MISSING_REPORT;

    const [tagMissingReportTableData, setTagMissingReportTableData] = useState<TAG_MISSING_REPORT[]>([]);

    useEffect(() => {
        setTagMissingReportTableData(TAG_MISSING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="TAG_MISSING"
        tableColumns={tagMissingReportTableColumns}
        tableData={tagMissingReportTableData} />
    );
}